import React, { useEffect, useState } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, query, orderBy, onSnapshot } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC58VKfUUehF4BqwkfFwunvTaGZgyhDtQU",
  authDomain: "crm-leads-shippix.firebaseapp.com",
  projectId: "crm-leads-shippix",
  storageBucket: "crm-leads-shippix.firebasestorage.app",
  messagingSenderId: "359918388635",
  appId: "1:359918388635:web:ccec48d954454cb98e4d3e",
  measurementId: "G-PVL81XXNT2"
};

const app = initializeApp(firebaseConfig, 'support-tickets');
const db = getFirestore(app);

interface TicketListProps {
  userEmail: string;
  onSelectTicket: (ticket: any) => void;
}

const STATUS_COLORS: Record<string, { bg: string, color: string }> = {
  'Novo': { bg: '#32a8f3', color: '#fff' },
  'Em tratamento': { bg: '#1c293a', color: '#fff' },
  'Aguardar': { bg: '#ffa600', color: '#222' },
  'Reclamação': { bg: '#f44336', color: '#fff' },
  'Seguro Reclamado': { bg: '#ffa600', color: '#222' },
  'Nota de Crédito': { bg: '#32a8f3', color: '#fff' },
  'Envio à Cobrança': { bg: '#f44336', color: '#fff' },
  'Desativação': { bg: '#f44336', color: '#fff' },
  'Contencioso': { bg: '#f44336', color: '#fff' },
  'Respondido': { bg: '#4caf50', color: '#fff' }
};

export default function TicketList({ userEmail, onSelectTicket }: TicketListProps) {
  const [tickets, setTickets] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const q = query(collection(db, 'tickets'), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const docs = querySnapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter((t: any) => t.email === userEmail);
      setTickets(docs);
      setLoading(false);
    });
    return () => unsubscribe();
  }, [userEmail]);

  if (loading) return <div>A carregar tickets...</div>;
  if (!tickets.length) return <div>Não existem tickets de suporte.</div>;

  return (
    <div>
      <h2 className="text-lg font-semibold mb-2">Os meus tickets de suporte</h2>
      <ul className="divide-y divide-gray-200">
        {tickets.map(ticket => (
          <li key={ticket.id}
              className="mb-3 rounded-lg shadow-sm bg-white hover:shadow-md transition flex flex-col gap-1 border border-gray-100 cursor-pointer p-3 group"
              onClick={e => {
                e.preventDefault();
                window.open(`https://cliente.shippix.pt/public/suporte/ticket/${ticket.ticketId}`, '_blank');
              }}>
            <div className="flex items-center justify-between gap-2">
              <span className="text-xs font-bold text-gray-500 bg-gray-100 rounded px-2 py-0.5 mr-2" style={{ minWidth: 80, letterSpacing: 1 }}>{ticket.ticketId}</span>
              <span className="flex-1 font-semibold text-base text-gray-800 truncate">{ticket.assunto || ticket.subject}</span>
              <span className="text-xs font-semibold ml-2" style={{
                background: STATUS_COLORS[ticket.statusName]?.bg,
                color: STATUS_COLORS[ticket.statusName]?.color,
                borderRadius: 20,
                padding: '4px 18px',
                display: 'inline-block',
                minWidth: 90,
                textAlign: 'center',
                fontWeight: 600
              }}>{ticket.statusName}</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-400 mt-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24"><path stroke="#b0b0b0" strokeWidth="2" d="M12 6v6l4 2"/></svg>
              <span>{ticket.createdAt?.toDate?.().toLocaleDateString?.('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' })} {ticket.createdAt?.toDate?.().toLocaleTimeString?.('pt-PT', { hour: '2-digit', minute: '2-digit' })}</span>
              {ticket.nomeCliente && <span className="ml-2 text-gray-500">• {ticket.nomeCliente}</span>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
